import { updateField } from 'vuex-map-fields';
import { findIndex } from 'lodash';
import moment from '@/helpers/momentz';

const mutations = {
  START_LOADING_MERCHANT_LIST(state) {
    state.loadingMerchantList = true;
  },
  SET_MERCHANTS(state, payload) {
    state.merchantList = payload;
    state.loadingMerchantList = false;
  },
  START_LOADING_MERCHANT(state) {
    state.merchantLoaded = false;
  },
  // Deprecated
  // SET_MERCHANT(state, payload) {
  //   state.merchant = payload;
  //   state.merchantLoaded = true;
  // },
  SET_MERCHANT(state, payload) {
    state.merchant[payload.id] = payload;
    state.merchantLoaded = true;
  },
  SET_SETTINGS(state, payload) {
    state.settings = payload;
  },
  SET_AVAILABILITIES(state, payload) {
    state.availabilities = payload;
  },
  SET_MERCHANT_PARTIAL_DATA(state, payload) {
    state.merchantName = payload.name;
    state.merchantLogo = payload.logo;
  },
  SET_MERCHANT_UPDATED(state, payload) {
    state.merchantUpdated = payload;
  },
  SET_LOGO(state, payload) {
    state.merchant.logo = payload.logo;
    if (state.merchantList.length) {
      const merchantIndex = findIndex(state.merchantList, merchant => merchant.id === payload.merchant_id);
      state.merchantList[merchantIndex].logo = payload.logo;
    }
  },
  // SET_FB_RECIPIENTS(state, payload) {
  //   state.facebookRecipients = payload;
  // },
  // FOUND_FB_RECIPIENTS(state, payload) {
  //   state.foundFacebookRecipients = payload;
  // },
  SET_MERCHANT_MEMBERS_INVITATIONS(state, payload) {
    state.membersAndInvitations = payload;
    state.loadingData = false;
  },
  SET_MEMBERS_META(state, meta) {
    state.membersMeta = meta;
  },
  UPDATE_MERCHANT_MEMBERS_INVITATIONS(state, payload) {
    const targetMember = state.membersAndInvitations.find(member => member.id === payload.targetMemberId);
    targetMember.role = payload.newData.role;
    targetMember.businesses = payload.newData.businesses;

    state.members = [...state.members];
  },
  UPDATE_MEMBER_INVITE(state, payload) {
    const targetMember = state.membersAndInvitations.find(member => member.id === payload.targetMemberId);
    targetMember.link = payload.newData.link;
    targetMember.expires_at = moment(payload.expiresAt).format('YYYY-MM-DD HH:mm:ss');

    state.members = [...state.members];
  },
  LOADING_MEMBERS(state, payload) {
    state.loadingMembers = payload;
  },
  SET_MERCHANT_MEMBERS(state, payload) {
    state.members = payload;
    state.loadingMembers = false;
  },
  SUBSCRIPTIONS_RELOADED(state, payload) {
    state.subscriptionsListReloaded = payload;
  },
  SET_SUBSCRIPTIONS(state, payload) {
    this.subscriptionsList = payload;
    localStorage.setItem('merchantSubscriptions', JSON.stringify(payload));
  },
  PERMISSION_ROLES_LOADED(state) {
    state.permissionRolesLoaded = false;
  },
  SET_PERMISSION_ROLES(state, payload) {
    state.permissionRoles = payload;
    state.permissionRolesLoaded = true;
  },
  SET_PERMISSIONS_IN_STORAGE(state, payload) {
    localStorage.setItem(`merchantPermissions.${payload.merchant_id}`, JSON.stringify(payload.data));
  },
  PERMISSION_ROLES_UPDATED(state, payload) {
    state.permissionRolesUpdated = payload;
  },

  APP_KEY_LOADED(state, payload) {
    state.appKeyLoaded = payload;
  },
  SET_APP_KEY(state, payload) {
    state.appKey = payload;
  },
  APP_KEY_UPDATED(state, payload) {
    state.appKeyUpdated = payload;
  },
  SET_ANALYTICS(state, payload) {
    state.analytics = payload;
  },
  AVAILABILITY_UPDATED(state, payload) {
    state.availabilityUpdated = payload;
  },
  MERCHANT_AVAILABILITY(state, payload) {
    const availabilities = { ...state.merchantAvailability };
    availabilities[payload.merchantId] = payload.available;
    state.merchantAvailability = { ...availabilities };
  },
  AVAILABILITY_TIMES_UPDATED(state, payload) {
    state.availabilityTimesUpdated = payload;
  },
  PLAN_SUBSCRIPTION_UPDATED(state, payload) {
    state.planSubscriptionUpdated = payload;
  },
  MEMBER_INVITED(state) {
    state.invitationSent = true;
  },
  MEMBER_ROLE_CHANGED(state, payload) {
    state.memberRoleChanged = payload;
  },
  MEMBER_TEAMS_CHANGED(state, payload) {
    state.memberTeamsChanged = payload;
  },
  MEMBER_DELETED(state, payload) {
    state.memberDeleted = payload;
  },

  INVITATION_DELETED(state, payload) {
    state.invitationDeleted = payload;
  },
  // STRIPE_DISCONNECTED(state) {
  //   state.merchant.payment_provider = {};
  //   state.stripeSuccessDisconnect = true;
  // },
  // STRIPE_CONNECTED(state) {
  //   state.stripeSuccessConnect = true;
  // },
  REMOVE_MEMBER_FROM_ORGANISATION(state, payload) {
    state.membersAndInvitations = state.membersAndInvitations.filter(member => member.id !== payload.user_uid);
  },
  ADD_MEMBER_TO_BUSINESS(state, payload) {
    const targetMember = state.membersAndInvitations.find(member => member.id === payload.user_uid);
    const businessAlreadyPresent = targetMember.businesses.map(business => business.uid).includes(payload.businessToAdd.uid);
    if (!businessAlreadyPresent) {
      targetMember.businesses = [...targetMember.businesses, payload.businessToAdd];
    }
    state.membersAndInvitations = [...state.membersAndInvitations];
  },
  REMOVE_MEMBER_FROM_BUSINESS(state, payload) {
    const targetMember = state.membersAndInvitations.find(member => member.id === payload.user_uid);
    targetMember.businesses = [...targetMember.businesses.filter(business => business.uid !== payload.business_uid)];
    state.membersAndInvitations = [...state.membersAndInvitations];
  },
  FETCHING_BLOCKED(state, status) {
    state.fetchingBlocked = status;
  },
  SET_BLOCKED_CONTACTS(state, payload) {
    state.blocklist = payload;
  },
  CLEAR_BLOCKED_CONTACTS(state) {
    state.blocklist = {};
  },
  ADD_BLOCKER_CONTACT_TO_LIST(state, payload) {
    state.blocklist.data.push(payload);
  },
  REMOVE_BLOCKER_CONTACT_FROM_LIST(state, contactId) {
    const targetContactIndex = state.blocklist.data.findIndex(blocked => blocked.id === contactId);
    state.blocklist.data.splice(targetContactIndex, 1);
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  updateField,
};

export default mutations;
